export default ({axios}) => ({
    extendsTrial: (userId, body = {}) => axios.post(`users/${userId}/subscription/extend-trial`, body)
})
